export const downloadPdf = (module) => {
  try {
    const pdfUrl = `/${module}.pdf`;
    fetch(pdfUrl)
      .then((resp) => resp.arrayBuffer())
      .then((resp) => {
        // set the blog type to final pdf
        const file = new Blob([resp], { type: "application/pdf" });

        // process to auto download it
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `New${module}processdetails.pdf`;
        link.click();
      });
  } catch (e) {
    console.log(e);
  }
};
